import { useIntl } from 'react-intl'

function useCruiseCabinDescriptions(): Record<string, string> {
  const intl = useIntl()

  return {
    Inside: intl.formatMessage({
      id: 'AVpgmQ/MVW',
      defaultMessage: 'An inside cabin is normally the most affordable option, often without a window.',
      description: 'Description of an inside cruise cabin type',
    }),
    Oceanview: intl.formatMessage({
      id: 'adAjdo2XQh',
      defaultMessage: 'An oceanview cabin, often called an outside cabin, is a room with a port hole or window that looks out to sea, depending on deck and location.',
      description: 'Description of an oceanview cruise cabin type',
    }),
    Window: intl.formatMessage({
      id: 'hfrADYGCia',
      defaultMessage: 'A window cabin is a room with a fixed picture window that looks onto the river and passing scenery, depending on deck and location.',
      description: 'Description of a window cruise cabin type',
    }),
    'Oceanview / Window': intl.formatMessage({
      id: 'VoZH3u7iXr',
      defaultMessage: 'An oceanview / window cabin is a room with a port hole or window that looks out to sea or river and passing scenery, depending on deck and location.',
      description: 'Description of an oceanview / window cruise cabin type',
    }),
    Balcony: intl.formatMessage({
      id: '8AyJ4r+mSL',
      defaultMessage: 'A balcony cabin is any cruise room with a private verandah, allowing you to take in the beautiful views and fresh air.',
      description: 'Description of a balcony cruise cabin type',
    }),
    Suite: intl.formatMessage({
      id: 'f31QM4kdca',
      defaultMessage: 'A suite is an especially large room within a cruise ship\u2019s top tier of cabins, often with a wide window and/or private verandah.',
      description: 'Description of a suite cruise cabin type',
    }),
  }
}

export default useCruiseCabinDescriptions
